import React from "react";
import { Link } from "react-router-dom";

function Footer(props) {
  const RenderList = () => {
    if (props.auth.isAuthenticated) {
      return [
        <div>
          <li>
            <Link to="/userhome">Home</Link>
          </li>
          <li>
            <Link to="/profile">Profile</Link>
          </li>
          <li>
            <Link to="/aboutus">About Us</Link>
          </li>
          <li>
            <Link to="/menu">My Goals</Link>
          </li>
          <li>
            <Link to="/contactus">Contact Us</Link>
          </li>
        </div>,
      ];
    } else {
      return [
        <div>
          <li>
            <Link to="/home">Home</Link>
          </li>

          <li>
            <Link to="/aboutus">About Us</Link>
          </li>

          <li>
            <Link to="/contactus">Contact Us</Link>
          </li>
        </div>,
      ];
    }
  };

  return (
    <div className="footer">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-4 offset-1 col-sm-2">
            <h5>Links</h5>
            <ul className="list-unstyled">
              {/* <li>
                <Link to="/home">Home</Link>
              </li>
              <li>
                <Link to="/userhome">User Home</Link>
              </li>
              <li>
                <Link to="/profile">Profile</Link>
              </li>
              <li>
                <Link to="/aboutus">About Us</Link>
              </li>
              <li>
                <Link to="/menu">My Goals</Link>
              </li>
              <li>
                <Link to="/contactus">Contact Us</Link>
              </li> */}
              <RenderList />
            </ul>
          </div>
          <div className="col-7 col-sm-5">
            <h5>Developed By</h5>
            <ul>
              <li>
                <a href="https://www.linkedin.com/in/tanya-pandhi-ba89481b3/">
                  Tanya Pandhi
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/teghdeep-kapoor-8ab2961aa/">
                  Teghdeep Kapoor
                </a>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-4 align-self-center">
            {/*<div className="text-center">
              <a
                className="btn btn-social-icon btn-google"
                href="http://google.com/+"
              >
                <i className="fa fa-google-plus"></i>
              </a>
              <a
                className="btn btn-social-icon btn-facebook"
                href="http://www.facebook.com/profile.php?id="
              >
                <i className="fa fa-facebook"></i>
              </a>
              <a
                className="btn btn-social-icon btn-linkedin"
                href="http://www.linkedin.com/in/"
              >
                <i className="fa fa-linkedin"></i>
              </a>
              <a
                className="btn btn-social-icon btn-twitter"
                href="http://twitter.com/"
              >
                <i className="fa fa-twitter"></i>
              </a>
              <a
                className="btn btn-social-icon btn-google"
                href="http://youtube.com/"
              >
                <i className="fa fa-youtube"></i>
              </a>
              <a className="btn btn-social-icon" href="mailto:">
                <i className="fa fa-envelope-o"></i>
              </a>
            </div>*/}
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-auto">
            <p>© Copyright 2020 Bachat</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/FooterComponent.js